import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { User } from 'src/app/models/User.model';
import { Login } from 'src/app/models/login.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ForgotPasswordComponent } from 'src/app/features/home/forgot-password/forgot-password.component';
import { UserdetailsService } from 'src/app/services/profile/userdetails.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ValidateOTPRequest } from 'src/app/models/validate-otp.model';
import { CreateOTPRequest } from 'src/app/models/create-otp.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  login = new Login("", "", "", "", "", "", "", "", "", "");
  validateOTPRequest = new ValidateOTPRequest("", "");
  showEmailError: boolean = false;
  // loginErrorMessage: string = "<p class='no-select mb-0'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>";
  loginErrorMessage: string = "&nbsp;";
  otpErrorMessage: string = "&nbsp;";
  isLoggedIn: boolean = false;
  fullname: string = "";
  initialLogin: boolean = false;
  otp: string = "";
  otpLength: number = 6;
  resendingOTP: boolean = false;
  resentOTP: boolean = false;
  resentOTPError: boolean = false;
  welcomeBack: boolean = false;
  loginBtnText: string = "Log In";
  verifyBtnText: string = "Verify";
  private otpRequestID: string = "";

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<LoginComponent>,
    private authService: AuthenticationService,
    private userDetailService: UserdetailsService,
    private domSanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry,
    private router: Router,
    private matDialog: MatDialog,
  ) {
    dialogRef.disableClose = true;
    if (data.email) {
      this.login.email = data.email;
      this.welcomeBack = true;
    }
    this.matIconRegistry
      .addSvgIcon(
        "close",
        this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/close-icon.svg')
      );
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onClickLogin(): void {
    this.authenticate();
  }

  authenticate(): void {
    if (this.login.email?.trim().length == 0) {
      this.showEmailError = true;
      this.loginErrorMessage = "Please enter your email address.";
      return;
    }
    if (this.login.password?.trim().length == 0) {
      this.showEmailError = true;
      this.loginErrorMessage = "Please enter your password!";
      return;
    }
    //To-do: Encryption disabled for soft production, to be enabled later
    //this.login.password = this.AESEncryptDecryptService.encrypt(this.login.password);
    this.loginBtnText = '<div class="spinner-border text-light" role="status"><span class="visually-hidden">Loading...</span></div>';
    this.authService.authenticateV2(this.login).subscribe({
      next: (res: any) => {
        // console.log(res);
        if (res?.body) {
          this.otpRequestID = res.body.otpRequestID;
          this.initialLogin = true;
          this.sendOTP();
        } else {
          this.otpRequestID = "";
          this.initialLogin = false;
          this.loginErrorMessage = "Login failed. Please try again.";
        }
        this.loginBtnText = 'Log In';
      },
      error: (err: any) => {
        this.otpRequestID = "";
        this.initialLogin = false;
        this.loginErrorMessage = "System unavailable. Please try again.";
        this.loginBtnText = 'Log In';
        console.log(err.message);
      }
    });
  }

  sendOTP(resend: boolean = false): void {
    if (resend) {
      if (this.resendingOTP) {
        return;
      }
      this.resendOTPTimeout(10);
    }
    const createOTPRequest = new CreateOTPRequest(this.otpRequestID);
    this.authService.sendOTP(createOTPRequest).subscribe({
      next: (res: any) => {
        // console.log(res);
        if (res?.status == true) {
          this.validateOTPRequest.otpRequestID = this.otpRequestID;
          if (resend) {
            this.resentOTP = true;
          }
        }
      },
      error: (err: any) => {
        if (err.status == 403) {
          this.reset();
          this.loginErrorMessage = "Your session has expired. Please login again.";
        } else {
          this.otpRequestID = "";
          this.initialLogin = false;
          this.resendingOTP = false;
          this.resentOTP = false;
          if (resend) {
            this.resentOTPError = true;
          }
          this.loginErrorMessage = "System unavailable. Please try again.";
        }
        console.log(err.message);
      }
    });
  }

  validateOTP(): void {
    if (this.otp?.trim().length == 0) {
      this.otpErrorMessage = "Please enter your Verification Code.";
      return;
    }
    this.verifyBtnText = '<div class="spinner-border text-light" role="status"><span class="visually-hidden">Loading...</span></div>';
    this.validateOTPRequest.otp = this.otp;
    this.authService.validateOTP(this.validateOTPRequest).subscribe({
      next: (res: any) => {
        if (res?.status) {
          sessionStorage.setItem("jwt", res.body.jWTToken.token);

          this.showEmailError = false;
          // this.errorMessage = "";
          this.login.accountID = res.body.accountID;
          this.login.firstName = res.body.firstName;
          this.login.lastName = res.body.lastName;
          this.login.address1 = res.body.address1;
          this.login.address2 = res.body.address2;
          this.login.city = res.body.city;
          this.login.stateCode = res.body.stateCode;
          this.login.zip = res.body.zip;
          this.login.email = res.body.email;
          this.authService.isAuthUser.next(res.status);
          this.authService.isAuthUser.subscribe((val => {
            this.isLoggedIn = val;
            this.fullname = this.login.firstName.trim() + " " + this.login.lastName.trim();
          }));
          let user = new User();
          user.accountID = res.body.accountID;
          user.firstName = res.body.firstName;
          user.lastName = res.body.lastName;
          user.email = res.body.email;
          user.address = res.body.address1;
          user.city = res.body.city;
          user.state = res.body.stateCode;
          user.zip = res.body.zip;
          this.authService.isAuthUser.next(true);
          this.authService.loggedInUser.next(new Login(res.body.email, "", res.body.firstName, res.body.lastName, res.body.accountID, res.body.address1, res.body.address2, res.body.stateCode, res.body.city, res.body.zip));
          this.authService.loggedInUserId.next(res.body.accountID);
          sessionStorage.setItem('loggedUser',JSON.stringify(new Login(res.body.email, "", res.body.firstName, res.body.lastName, res.body.accountID, res.body.address1, res.body.address2, res.body.stateCode, res.body.city, res.body.zip)))
          this.authService.setUserDetailModel(user);
          if (res.body.istempPassword) {
            this.authService.isTempPassword = true;
            this.router.navigate(['myprofile/change-password']);
          }
          this.dialogRef.close("loggedIn");

          this.closeDialog();

          if (!this.welcomeBack) {
            this.router.navigate(['/coverages']);
          }
          // this.router.navigate(['/home']);
          // this.verifyBtnText = 'Verify';
        } else {
          this.otpErrorMessage = "Invalid Code. Please try again.";
          this.verifyBtnText = 'Verify';
        }
      },
      error: (err: any) => {
        if (err.status == 401) {
          this.loginErrorMessage = "Maximum attempts reached. Please login again.";
          this.reset();
        } else if (err.status == 403) {
          this.loginErrorMessage = "Your session has expired. Please login again.";
          this.reset();
        } else {
          this.otpErrorMessage = "System unavailable. Please try again.";
        }
        this.verifyBtnText = 'Verify';
        console.log(err.message);
      }
    });
  }

  OpenForgotPasswordDialog() {
    this.matDialog.open(
      ForgotPasswordComponent,
      {
        panelClass: 'forgot-password-modal',
        autoFocus: true,
        data: this.login.email
      });
  }

  resendOTPTimeout(seconds: number): void {
    this.resendingOTP = true;
    this.resentOTPError = false;
    setTimeout(() => {
      this.resendingOTP = false;
    }, seconds * 1000);
  }

  reset(): void {
    const email = this.login.email;
    this.login = new Login(email, "", "", "", "", "", "", "", "", "");
    this.validateOTPRequest = new ValidateOTPRequest("", "");
    this.otpRequestID = "";
    this.otp = "";
    this.resendingOTP = false;
    this.resentOTP = false;
    this.resentOTPError = false;
    this.initialLogin = false;
    this.otpErrorMessage = "&nbsp;";
  }
}
